import Vue from 'vue'
import VueRouter from 'vue-router'
import palce from '../views/palce.vue'
import review from '../views/review.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'palce',
    component: palce
  },
  {
    path: '/review',
    name: 'review',
    component: review
  },
 
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
